import {IPinExtraDataService} from "../services/pin-extra-data-service";
import {
    EnvironmentalSusceptibility,
    ISMUWithFactsheetType,
    ISoilQueryPartial,
    SoilInformation
} from "../lt-ng/soil-information";
import {_F} from "../utility/func";
import pinColorFromFeature = _F.pinColorFromFeature;
import {ISmuFactsheetService} from "../services/smap/smu-factsheet-service";
import {LTServices} from "../lt-ng/lt-services";
import IMapService = LTServices.IMapService;
import {L} from "../lt-ng/landcare-toolkit";
import getScienceLayers = L.tree.getScienceLayers;
import {IReportFromUrlService} from "../services/smap/report-from-url-service";
import {PinAndExtras} from "../services/PinApi";
import {IPointReport, PinReport} from "../services/ISharedFeatureState";
import {IPortalServices} from "../lt-ng/portal-services";

interface ISMapPointReportControllerBindings {
    pointReport: PinReport;
    error: any;
    onSave(data: {report: PinReport});
    onDelete(data: {report: PinReport});
    onRemove(data: {report: PinReport});
    onShare(data: {report: PinReport});
    onDismiss(data: {report: PinReport});
}
const sharedGroupStatus =  {
    siblings: true,
    location: false,
    chemicalAnalysis: false,
    risk: false
};

class SMapPointReportController implements ng.IComponentController, ISMapPointReportControllerBindings {
    pointReport: PinReport = null;
    soilInformation: SoilInformation;
    onSave: (data: { report: PinReport, changedProperties?: string[] }) => void;
    onDelete: (data: { report: PinReport }) => void;
    onRemove: (data: { report: PinReport }) => void;
    onShare: (data: { report: PinReport }) => void;
    onDismiss: (data: {report: PinReport}) => void;

    error: any;
    siblingData: IPointReport;

    groupStatus = sharedGroupStatus;

    [s: string]: any;

    constructor(protected pinExtraDataService: IPinExtraDataService,
                protected $uibModal,
                protected smuFactsheetService: ISmuFactsheetService,
                protected mapService: IMapService,
                protected reportFromUrlService: IReportFromUrlService,
                protected portalServices: IPortalServices) {

    }

    accordionGroupClass(isExpanded: boolean) {
        return {
            'icon-dropdown-closed': isExpanded,
            'icon-dropdown-open':  !isExpanded
        };
    }

    get pinData(): PinAndExtras {
        return this.pointReport.point.get('pin') || {};
    }

    get pinTitle(): string {
        try {

            return this.pinData.data.title
        } catch (e) {
            console.warn(e);
            return '';
        }
    }

    set pinTitle(title: string){
        try {
            this.pinData.data.title = title;
            const ufs = this.pointReport && this.pointReport.userFeatures && this.pointReport.userFeatures.userFeature;
            if (ufs) ufs.title = title;
        } catch (e) {
            console.warn(e);
        }
    }

    _extraQueryLayers;
    get extraQueryLayers() {
        if (!this._extraQueryLayers) {
            const sciLayers = getScienceLayers(this.mapService.treeData);
            this._extraQueryLayers = sciLayers
                .filter(l => l && l.layerService && l.layerService.attributes && l.layerService.attributes.SMapExtraSoilAttributes === 'Soil Chemistry');
        }

        return this._extraQueryLayers;
    }

    _riskLayersRequest: {
        result: EnvironmentalSusceptibility;
        error?: Error|undefined;
    };
    get riskLayers() {
        if (!this._riskLayersRequest) {
            const layer = 'smap_nitrogen_leach_risk';
            const result: this['_riskLayersRequest'] = {
                result: undefined
            }

            this._riskLayersRequest = result;

            this.portalServices.dataPointQuery(
                [this.pinData.data.x, this.pinData.data.y],
                [layer],
                { cache: true },
                false
            ).then((resp) => {
                if ('response' in resp) {
                    try {
                        result.result = new EnvironmentalSusceptibility(resp.response);
                        console.log(result);
                    } catch (e) {
                        result.error = e;
                        console.warn(e);
                    }

                }
            });
        }

        return this._riskLayersRequest;
    }

    highlightPin(onOrOff) {
        try {
            this.pointReport.userFeatures.mapFeatures.forEach(f => f.set('hover', onOrOff));
        } catch (e) {

        }
    }

    pinColor() {
        try {
            const f = this.pointReport.userFeatures.mapFeatures[0];
            return pinColorFromFeature(f);
        } catch (e) {

        }

        return 'black';
    }

    saveActiveFeature(propertiesToSave: string[] = undefined) {
        if (this.isReportSaved()) {
            this.onSave({report: this.pointReport, changedProperties: propertiesToSave});
        }
    }

    isReportSaved = () => {
        try {
            return !!this.pointReport.userFeatures.userFeature.id
        } catch (e) {
            return false;
        }
    };

    height = () => this.siblingData && this.siblingData.response && this.siblingData.response.pointHeight || 0;

    rows: ISoilQueryPartial[] = [];
    teReoParams: Map<number, ISMUWithFactsheetType> = new Map();

    public loading() {
        return !(this.pointReport && this.siblingData) && !this.error;
    }

    public retry() {
        this.error = null;
        // this.loadPointQueryData();
        const pointReport=  this.pointReport;

        if (!pointReport) return;

        const ks = Object.keys(this.pointReport.queryResults);
        if (!ks.length) return;

        const queryResult = this.pointReport.queryResults[ks[0]];

        if (queryResult) {
            queryResult.request.retry();
            this.loadPointQueryData();
        }
    }

    protected loadPointQueryData(): void {
        const pointReport=  this.pointReport;

        if (!pointReport) return;

        const ks = Object.keys(this.pointReport.queryResults);
        if (!ks.length) return;

        const queryResult = this.pointReport.queryResults[ks[0]];

        if (queryResult) {
            this.rows = [];
            this.siblingData = null;
            this.error = null;

            queryResult.request.request.then(resp => {
                if ('error' in resp) {
                    this.error = resp.error;
                    this.rows = [];
                } else {
                    this.siblingData = resp;

                    // const pin = pointReport.pinData && pointReport.pinData.data;
                    const f = pointReport.point;

                    if (!f) return;

                    const coord = f.getGeometry().getCoordinates();

                    this.soilInformation = new SoilInformation(coord, resp.response);
                    this.rows = this.soilInformation.rows();
                    this.teReoParams = new Map();
                    this.rows.forEach(r => {
                        this.teReoParams.set(r.index, this.teReoFactsheetParams(r.index));
                    });
                }
            }, err => {
                this.error = err;
                this.rows = [];
            })
        }
    }

    public $onChanges(onChangesObj: angular.IOnChangesObject): void {
        const pointReportChanged = !!onChangesObj.pointReport;

        if (pointReportChanged) {
            this.loadPointQueryData();
            this._riskLayersRequest = undefined;
        }
    }

    isNoData() {
        try {
            return !this.loading()
                && this.siblingData.response.poiType === 'NotSmap';
        } catch (e) {
            return false;
        }
    }

    isFeatureNoData() {
        const resp = this.siblingData && this.siblingData.response;
        return !this.loading()
            && (resp && resp.poiType
                && !this.isNoData()
                && !this.isSMap()
                && !this.isECAN() || (resp && resp.featureType === 'sea'));
    }

    isSMap() {
        return !this.loading()
            && this.soilInformation && this.soilInformation.isSmap();
    }

    isECAN() {
        return !this.loading()
            && this.soilInformation && this.soilInformation.isECAN();
    }

    featureType() {
        try {
            return this.siblingData.response.poiType || this.siblingData.response.featureType;
        } catch (e) {
            return '';
        }
    }

    _mainAttributes: any[];
    mainAttributes() {
        return this._mainAttributes || [];
    };

    public save() {
        this.onSave({report: this.pointReport});
    }

    public delete() {
        if (this.isReportSaved()) {
            this.onDelete({report: this.pointReport});
        } else  {
            this.onRemove({report: this.pointReport});
        }
    }

    public remove() {
        this.onRemove({report: this.pointReport});
    }

    public share() {
        this.onShare({report: this.pointReport});
    }

    public isDeleting() {
        try {
            return this.pointReport.userFeatures.deleting;
        } catch (e) {
            return false;
        }
    }

    public isReportSaving() {
        try {
            return this.pointReport.userFeatures.saving;
        } catch (e) {
            return false;
        }
    }

    public showEditDialog() {
        const title = this.pinTitle;

        const {result} = this.$uibModal.open({
            animation: true,
            backdrop: true,
            component: 'editTitle',
            size: 'lg',
            // scope: $scope,
            appendTo: _F.elemToAppendModal(),
            resolve: {
                title: () => title
            }
        });

        result.then((resolvedValue) => {
            console.log(resolvedValue);
            this.pinTitle = resolvedValue;
            if (this.isReportSaved()) {
                this.onSave({report: this.pointReport});
            }
        }, () => {
            console.log('dialog dismissed');
        });
    }

    public hasSMU() {
        return !!this.smu();
    }

    public smu() {
        return this.soilInformation && this.soilInformation.smu();
    }

    protected get pinCoordinate() {
        return this.pointReport.point.getGeometry().getCoordinates();
    }

    public smuLabel() {
        if (this.hasSMU()) {
            const smu = this.smu();
            return `${smu.soilmapuc} factsheet`;
        } else {
            return 'Soil Map Unit';
        }
    }

    public showSMUFactsheet($event: Event) {
        this.reportFromUrlService.showFactsheet(this.smu(), this.pinCoordinate);
        // this.smuFactsheetService.showSMUFactsheet(this.smu(), this.pinCoordinate, this.mapService);
        $event.preventDefault();
        return false;
    }

    public get smuFactsheetLink() {
        return this.smuFactsheetService.getFactsheetLink(this.smu(), this.pinCoordinate);
    }

    public teReoFactsheetUrl(siblingNumber: number) {
        return this.smuFactsheetService.getFactsheetLink(this.teReoFactsheetParams(siblingNumber), this.pinCoordinate);
    }

    public teReoFactsheetParams(siblingNumber: number): ISMUWithFactsheetType {
        return {
            ...this.smu(),
            factsheetType: "teReoSibling",
            objectId: this.soilInformation && this.soilInformation.objectId(),
            siblingNumber
        }
    }

    /*public showTeReoFactsheet($event: Event) {
        this.smuFactsheetService.showSMUFactsheet({ ...this.smu(), factsheetType: "teReoSibling" }, this.pinCoordinate, this.mapService);
        $event.preventDefault();
        return false;
    }*/
}

export class SMapPointReport implements ng.IComponentOptions {
    public controller = [
        'pinExtraDataService',
        '$uibModal',
        'smuFactsheetService',
        'landcareMapService',
        'reportFromUrlService',
        'portalServices',
        SMapPointReportController
    ];

    public bindings = {
        error: '<',
        pointReport: '<',
        onSave: '&',
        onDelete: '&',
        onRemove: '&',
        onShare: '&',
        onDismiss: '&'
    };

    public templateUrl = '/Partial/component/SMapPointReport'
}
